const email = ({ emailSubject, image, emailBody, property, orgColors }) => `
<style>
@import url("https://fonts.googleapis.com/css?family=Raleway");
@import url("https://fonts.googleapis.com/css?family=Open+Sans");
*{
  font-family: "Open Sans", sans-serif;
}
</style>

<div style="margin:auto;background:white; width:100%; max-width:843px;">
  <div
    style='font-family: "Open Sans", sans-serif; margin-top:64px; text-align:center; font-size:18px; color:#333333 !important; text-align:left; border-bottom:1px solid #eee; width:90%; margin:auto; margin-top:40px; padding-bottom:8px;'>
    ${emailSubject}
  </div>
  <div style="width:100%; text-align:center; margin-top:38px;">
    <a href="{%suborg.property_logo_dark.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src="${property.logo}" alt="property-logo" style="max-height:84px;" />
    </a>
  </div>

  <div style="text-align:center; margin-top:30px;">
    <img src="${image}" alt="banner"
      style="max-width:600px; width:90%; max-height:340px;" />
  </div>

  <div
    style='text-align:left; font-family: "Open Sans", sans-serif; color:#333333 !important; font-weight:400; font-size:16px; line-height:24px; margin:20px auto; max-width:600px; width:90%;'>
    ${emailBody.replace(/\n/g, '<br/>')}
  </div>

  <div style="margin-top:48px;  text-align:center">
    <a href="{%hyraf_enroll_url%}" target="_blank" style="margin:auto;" >
        <button style='font-family: "Open Sans", sans-serif; 
        width:240px; 
        height:48px; 
        background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
        line-height: 24px; 
        font-size: 16px; 
        font-weight: 600; 
        text-transform: capitalize; 
        text-decoration:none; 
        margin:auto;'>
          Enroll Now
        </button>
    </a>
  </div>


  <div style="margin:48px auto; width:90%; max-width:600px; ">
    <div style='text-align:left; font-family: "Open Sans", sans-serif; color:black; font-size:16px; line-height:24px;'>
      Best regards</div>
    <div
      style="text-align:left; font-family: {%suborg.font_family%}; color:black; font-size:16px; line-height:24px; font-weight:600;">
      ${property.name}</div>
  </div>


  <div style="margin-top:48px; text-align:center;">
    <a href="{%suborg.property_manager_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src="${property.orgLogo}" alt="footer-logo" style="max-height:84px;" />
    </a>
  </div>

  <div style="text-align:center;">
    <a href="{%suborg.fair_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968"" alt="Fair Housing Icon" width="24"
        height="24"></a>
    <a href="{%suborg.equal_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968"" alt="Equal Housing Icon" width="24"
        height="24"></a>
  </div>


  <div style="margin-top:31px; text-align:center; margin-bottom:32px;">
    <a target="_blank" href="{%unsubscribe_url%}"
      style="font-family: "Open Sans", sans-serif; font-size:14px; color:#999999;font-weight:600;line-height:24px; text-decoration:none;">Unsubscribe</a>
  </div>


</div>`

const residentInvite = ({ residentInviteEmailSubject, residentInviteEmailBody, tourCtaText, contactCtaText, residentInviteImage, property, friendInviteEmailHeader, orgColors, subtitle }) => `
  <style type="text/css">
body {
  margin: 0 0 0 0;
  -webkit-text-size-adjust: none;
  font-family: "Open Sans", sans-serif;
}

*{
  font-family: "Open Sans", sans-serif;
}

.feature-image img {
  max-width: 100% !important;
}
@media screen and (max-width: 599px) {    
  .feature-image img {
    width: 100% !important;
  }
}


    .n-event-banner {
      max-width: 600px;
      max-height: 340px;
      width: 80%;
      margin: auto;
    }

@media only screen and (min-width: 320px) and (max-width: 480px) {
   .refer-btn-1{
   margin-right:0 !important;
 }
.refer-btn-2{
  margin-top:20px !important;
  margin-left:0 !important;
}
.email-subject-mobile{
  display:block !important;
}
}
.email-subject-mobile{
  display:none;
}

  </style>
<div style="margin:auto;background:white; width:100%; max-width:843px;">
${residentInviteEmailSubject ? `  <div
    class="email-subject-mobile"
    style="font-family: {%suborg.font_family%}; margin-top:64px; text-align:center; font-size:18px; color:#333333 !important; text-align:left; border-bottom:1px solid #eee; width:90%; margin:auto; margin-top:40px; padding-bottom:8px;">
    ${residentInviteEmailSubject}
  </div>`: ""
  }


  <div style="width:100%; text-align:center; margin-top:38px;">
    <a href="{%suborg.property_logo_dark.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src="${property.logo}" alt="property-logo" style="max-height:84px;" />
    </a>
    ${friendInviteEmailHeader ? ` <div style = "font-family: {%suborg.font_family%}; font-size:24px; color:#333333 !important; margin-top:15px; font-weight:600;" > ${friendInviteEmailHeader}</div>` : ""}
     
  </div>

  <div style="text-align:center; margin-top:30px;">
    <img class="n-event-banner feature-image" src="${residentInviteImage}" alt="banner"
      style="max-width:600px; width:90%; max-height:340px;" />
  </div>
  ${subtitle ? `<div style="text-align:center; font-family: {%suborg.font_family%}; color:#333333 !important; font-weight:600; font-size:18px; line-height:24px;margin:auto; margin-top:20px; max-width:600px; width:90%; ">${subtitle}</div>` : ""}

  <div
    style="text-align:left; font-family: {%suborg.font_family%}; color:#333333 !important; font-weight:400; font-size:16px; line-height:24px; margin:20px auto; max-width:600px; width:90%; ">
   ${residentInviteEmailBody.replace(/\n/g, '<br/>')}
  </div>

<div style="margin-top:48px; text-align:center">
  <a href="{%hyraf_tour_community_url%}" target="_blank">
    <button class ="refer-btn-1" style="font-family: {%suborg.font_family%}; 
      border:none;
      min-width:220px; 
      height:48px; 
         background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
      line-height: 24px; 
      font-size: 16px; 
      font-weight: 600; 
      text-transform: capitalize; 
      text-decoration:none; 
      margin:auto; 
      margin-right:10px;"
    >
     ${tourCtaText}
    </button>
  </a>
  <a href="{%suborg.contact_us_link.url%}" target="_blank">
    <button class ="refer-btn-2" style="font-family: {%suborg.font_family%}; 
      border:1px solid #333333;
      min-width:220px; 
      height:48px; 
      background: #FFFFFF; 
      color:#333333; 
      line-height: 24px; 
      font-size: 16px; 
      font-weight: 600; 
      text-transform: capitalize; 
      text-decoration:none; 
      margin:auto; 
      outline:none;
      margin-left:10px;">
     ${contactCtaText}
    </button>
  </a>
</div>


  <div style="margin:48px auto; width:90%; max-width:600px; ">
    <div style="text-align:left; font-family: {%suborg.font_family%}; color:black; font-size:16px; line-height:24px;">
      Best regards</div>
    <div
      style="text-align:left; font-family: {%suborg.font_family%}; color:black; font-size:16px; line-height:24px; font-weight:600;">
      ${property.name}</div>
  </div>


  <div style="margin-top:48px; text-align:center;">
    <a href="{%suborg.property_manager_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src=${property.orgLogo}" alt="footer-logo" style="max-height:84px;" />
    </a>
  </div>

  <div style="text-align:center;">
    <a href="{%suborg.fair_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968" alt="Fair Housing Icon" width="24"
        height="24"></a>
    <a href="{%suborg.equal_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968" alt="Equal Housing Icon" width="24"
        height="24"></a>
  </div>


  <div style="margin-top:31px; text-align:center; margin-bottom:32px;">
    <a target="_blank" href="{%unsubscribe_url%}"
      style="font-family: {%suborg.font_family%}; font-size:14px; color:#999999;font-weight:600;line-height:24px; text-decoration:none;">Unsubscribe</a>
  </div>
</div>`


const residentReward = ({ residentDiscountEmailSubject, residentDiscountImage, residentDiscountEmailBody, property, orgColors, rewardEmailHeader }) => `
<style>
@import url("https://fonts.googleapis.com/css?family=Raleway");
@import url("https://fonts.googleapis.com/css?family=Open+Sans");
*{
  font-family: "Open Sans", sans-serif;
}
</style>
<div style="margin:auto;background:white; width:100%; max-width:843px;">

  <div
    class="email-subject-mobile"
    style="padding-bottom: 8px; font-family: {%suborg.font_family%}; text-align:center; font-size:18px; color:#333333 !important; text-align:left; border-bottom:1px solid #eee; width:90%; margin:auto; margin-top:40px;">
    ${residentDiscountEmailSubject}
  </div>

  <div style="width:100%; text-align:center; margin-top:38px;">
    <a href="{%suborg.property_logo_dark.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src="${property.logo}" alt="property-logo" style="max-height:84px;" />
    </a>
    <div style="font-family: {%suborg.font_family%}; font-size:24px; color:#333333 !important; margin-top:15px; font-weight:600;">${rewardEmailHeader}</div>
  </div>
  <div style="text-align:center; margin-top:30px;">
    <img class="n-event-banner feature-image" src="${residentDiscountImage}" alt="banner"
      style="max-width:600px; width:90%; max-height:340px;" />
  </div>

  <div
    style="text-align:left; font-family: {%suborg.font_family%}; color:#333333 !important; font-weight:400; font-size:16px; line-height:24px; margin:20px auto; max-width:600px; width:90%; ">
    ${residentDiscountEmailBody.replace(/\n/g, '<br/>')}
  </div>

  <div style="margin-top:48px;  text-align:center">
<a href="{%hyraf_refer_again_url%}" target="_blank" style="margin:auto;" >
    <button style="font-family: {%suborg.font_family%}; 
    border:none;
    width:240px; 
    height:48px; 
      background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
    line-height: 24px; 
    font-size: 16px; 
    font-weight: 600; 
    text-transform: capitalize; 
    text-decoration:none; 
    margin:auto;">
      Refer Again
    </button>
</a>
  </div>


  <div style="margin:48px auto; width:90%; max-width:600px; ">
    <div style="text-align:left; font-family: {%suborg.font_family%}; color:black; font-size:16px; line-height:24px;">
      Best regards</div>
    <div
      style="text-align:left; font-family: {%suborg.font_family%}; color:black; font-size:16px; line-height:24px; font-weight:600;">
      ${property.name}</div>
  </div>


  <div style="margin-top:48px; text-align:center;">
    <a href="{%suborg.property_manager_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src=" ${property.orgLogo}" alt="footer-logo" style="max-height:84px;" />
    </a>
  </div>

  <div style="text-align:center;">
    <a href="{%suborg.fair_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968" alt="Fair Housing Icon" width="24"
        height="24"></a>
    <a href="{%suborg.equal_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968" alt="Equal Housing Icon" width="24"
        height="24"></a>
  </div>


  <div style="margin-top:31px; text-align:center; margin-bottom:32px;">
    <a target="_blank" href="{%unsubscribe_url%}"
      style="font-family: {%suborg.font_family%}; font-size:14px; color:#999999;font-weight:600;line-height:24px; text-decoration:none;">Unsubscribe</a>
  </div>


</div>
`


const thankYouEmail = ({ residentThankYouEmailSubject, residentThankYouImage, residentThankYouEmailBody, property, orgColors, residentThankYouEmailTitle }) => `
<style>
@import url("https://fonts.googleapis.com/css?family=Raleway");
@import url("https://fonts.googleapis.com/css?family=Open+Sans");
*{
  font-family: "Open Sans", sans-serif;
}
</style>
<div style="margin:auto;background:white; width:100%; max-width:843px;">

  <div
    class="email-subject-mobile"
    style="padding-bottom: 8px; font-family: {%suborg.font_family%}; text-align:center; font-size:18px; color:#333333 !important; text-align:left; border-bottom:1px solid #eee; width:90%; margin:auto; margin-top:40px;">
    ${residentThankYouEmailSubject}
  </div>

  <div style="width:100%; text-align:center; margin-top:38px;">
    <a href="{%suborg.property_logo_dark.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src="${property.logo}" alt="property-logo" style="max-height:84px;" />
    </a>
    <div style="font-family: {%suborg.font_family%}; font-size:24px; color:#333333 !important; margin-top:15px; font-weight:600;">${residentThankYouEmailTitle}</div>
  </div>
  <div style="text-align:center; margin-top:30px;">
    <img class="n-event-banner feature-image" src="${residentThankYouImage}" alt="banner"
      style="max-width:600px; width:90%; max-height:340px;" />
  </div>

  <div
    style="text-align:left; font-family: {%suborg.font_family%}; color:#333333 !important; font-weight:400; font-size:16px; line-height:24px; margin:20px auto; max-width:600px; width:90%; ">
    ${residentThankYouEmailBody ? residentThankYouEmailBody.replace(/\n/g, '<br/>') : ""}
  </div>

  <div style="margin-top:48px;  text-align:center">
<a href="{%hyraf_refer_again_url%}" target="_blank" style="margin:auto;" >
    <button style="font-family: {%suborg.font_family%}; 
    border:none;
    width:240px; 
    height:48px; 
      background:${orgColors ? orgColors.buttonBackgroundColor : '#27bbed'};
  color:${orgColors ? orgColors.buttonFontColor : 'white'};
  border:${orgColors ? orgColors.buttonBorderColor : '#27bbed'};
    line-height: 24px; 
    font-size: 16px; 
    font-weight: 600; 
    text-transform: capitalize; 
    text-decoration:none; 
    margin:auto;">
      Refer Now
    </button>
</a>
  </div>

  <div style="margin-top:48px; text-align:center;">
    <a href="{%suborg.property_manager_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank">
      <img src=" ${property.orgLogo}" alt="footer-logo" style="max-height:84px;" />
    </a>
  </div>

  <div style="text-align:center;">
    <a href="{%suborg.fair_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968" alt="Fair Housing Icon" width="24"
        height="24"></a>
    <a href="{%suborg.equal_housing_logo.url%}?utm_medium=Email&utm_source=Hyly&utm_campaign=hyEvents&utm_content={%email_name_encoded%}-events"
      target="_blank"><img src="https://s3.amazonaws.com/img.myhyly/1642424401475157430/Abe_Residential/Avenue_at_York/optimized/original.?1566337968" alt="Equal Housing Icon" width="24"
        height="24"></a>
  </div>


  <div style="margin-top:31px; text-align:center; margin-bottom:32px;">
    <a target="_blank" href="{%unsubscribe_url%}"
      style="font-family: {%suborg.font_family%}; font-size:14px; color:#999999;font-weight:600;line-height:24px; text-decoration:none;">Unsubscribe</a>
  </div>


</div>
`
export const htmls = {
  email,
  residentInvite,
  residentReward,
  thankYouEmail
}